import React from 'react';

import 'react-datepicker/dist/react-datepicker.css';

import './style.less';
import Menus from '../../components/Menu';

const CommunityMenus = () => {
    return (
        <div className="relative-list food-menu">
            <Menus />
        </div>
    );
};

export default CommunityMenus
